import { Box, Button, Text } from "@prismicio/editor-ui"

interface SetUpPreviewCardProps {
  onShowDialog: () => void
}
export function SetUpPreviewCard({ onShowDialog }: SetUpPreviewCardProps) {
  return (
    <Box
      backgroundColor="grey1"
      borderRadius={8}
      border
      padding={16}
      gap={12}
      flexDirection="column"
    >
      <Box flexDirection="column" gap={4} display="flex">
        <span style={{ fontSize: "24px" }}>⚠️</span>
        <Text variant="bold" color="purple9">
          Live Editing configuration needs to be finalized
        </Text>
        <Text variant="normal" color="grey11">
          See content changes in real-time by completing the live editing
          configuration.
        </Text>
      </Box>
      <Box>
        <Button
          color="purple"
          onClick={onShowDialog}
          endIcon="arrowForward"
          invisible
        >
          Get the live preview
        </Button>
      </Box>
    </Box>
  )
}
